<template>
  <q-page padding class="layout-constrained">
    <div class="q-pa-md text-center" data-testid="not-found">
      <h1 class="text-h4">Page not found</h1>
      <p class="text-body1">
        We could not find that page. It may have moved, or the link may be wrong.
      </p>
      <q-btn color="primary" label="Go to Explore" :to="{ name: 'explore' }" />
    </div>
  </q-page>
</template>
